export const obtenerValorSaldo = (total, abonos) => {


    let abos = totalArr(abonos)

    return total - abos

}

export const totalArr = (arr) => {

    if (!arr) {
        return 0
    }

    let total = 0
    for (let i = 0; i < arr.length; i++) {
        total += parseInt(arr[i].valor)
    }

    return total
}